module.exports = __webpack_public_path__ + "1d1bf46e987414a5302533f57973eb71.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/news/isaac.jpg
// module id = 289
// module chunks = 0